import { escape as o } from "./utils/escape.js";
import { htmlToTextContent as l, unescape as p } from "./utils/unescape.js";
import { hasNativeEmojiSupport as m, substituteUnicodeForColonified as d } from "./utils/emoji.js";
import { encodeAttributes as f } from "./utils/attribute-encoding.js";
import { MENTION_CLASS as h } from "./constants.js";
class z {
  schema;
  config;
  text;
  nodeNameMap = {
    bold: "b",
    italic: "i",
    anchor: "a",
    code: "code",
    span: "span"
  };
  constructor(e, t) {
    this.schema = e, this.config = t, this.text = "";
  }
  serializeNode(e) {
    const t = [];
    return e.content.forEach((s) => {
      let a = s.marks || [];
      switch (a = this.filterSerializableMarks(a), this.maybeCloseMarks(t, a), s.type) {
        case this.schema.nodes.hardBreak:
          this.text += "<br>";
          break;
        case this.schema.nodes.text:
          this.maybeOpenMarks(t, a), this.serializeText(s);
          break;
        case this.schema.nodes.template:
          this.maybeOpenMarks(t, a), this.serializeTemplate(s);
          break;
        case this.schema.nodes.mention:
          this.serializeMention(s);
          break;
        case this.schema.nodes.aiPromptData:
          this.serializeAiPromptData(s);
          break;
        case this.schema.nodes.marker:
          break;
        case this.schema.nodes.inlineImage:
          this.serializeImage(s);
          break;
        default:
          throw new Error("Invalid node type in text");
      }
    }), this.maybeCloseMarks(t, []), this.text;
  }
  filterSerializableMarks(e) {
    return e.filter((t) => t.type.spec.serializable !== !1);
  }
  maybeCloseMarks(e, t) {
    if (e.filter((i) => !t.includes(i)).length === 0)
      return;
    const a = e.pop();
    if (!a)
      throw new Error("unreachable");
    this.addClosingTag(a.type), this.maybeCloseMarks(e, t);
  }
  maybeOpenMarks(e, t) {
    t.filter((a) => !e.includes(a)).forEach((a) => {
      e.push(a), this.addOpeningTag(a);
    });
  }
  serializeText(e) {
    let t = e.text ?? "";
    m() || (t = d(t)), this.config?.plaintextSerialization ? this.text += this.handlePlaintextSerialization(t) : this.text += this.escape(t);
  }
  handlePlaintextSerialization(e) {
    const { entityHandling: t = "escape", sanitize: s = !1 } = this.config.plaintextSerialization ?? {};
    switch (t) {
      case "unescape": {
        const a = p(e);
        return typeof s == "function" ? s(a) : a;
      }
      case "textContent":
        return l(e);
      case "escape":
      default:
        return this.escape(e);
    }
  }
  serializeTemplate(e) {
    this.text += `{{${this.escape(e.attrs.attributePath)}`, e.attrs.fallback && (this.text += `|fallback:"${this.escape(e.attrs.fallback)}"`), this.text += "}}";
  }
  serializeMention(e) {
    this.text += `<a class="${h}" href="${this.escape(e.attrs.uri)}">${this.escape(
      e.attrs.name
    )}</a>`;
  }
  serializeAiPromptData(e) {
    let t = "<span data-ai-prompt-data";
    Object.entries(e.attrs).forEach(([s, a]) => {
      if (a) {
        const i = s.replace(/[A-Z]/g, (r) => `-${r.toLowerCase()}`);
        t += ` data-prompt-data-${i}="${this.escape(a)}"`;
      }
    }), this.text += `${t}></span>`;
  }
  serializeImage(e) {
    const { displayWidth: t, width: s, src: a, linkUrl: i, text: r, className: c } = e.attrs;
    let n = `<img class="${h} inline-image" src="${this.escape(a)}" width="${// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    t || s}"${r ? ` alt="${this.escape(r)}"` : ""}${c ? ` data-class-name="${this.escape(c)}"` : ""}>`;
    i && (n = `<a href="${this.escape(i)}">${n}</a>`), this.text += n;
  }
  addClosingTag(e) {
    this.text += `</${this.nodeNameMap[e.name]}>`;
  }
  addOpeningTag(e) {
    this.text += `<${this.nodeNameMap[e.type.name]}`, e.attrs && this.addAttrs(e), this.text += ">";
  }
  addAttrs(e) {
    Object.keys(e.attrs).forEach((t) => {
      const s = f(e.attrs[t]), a = this.escape(s);
      a && (this.text += ` ${t}="${a}"`);
    });
  }
  escape(e) {
    return o(e);
  }
}
export {
  z as TextSerializer
};
